import React, { useEffect, useRef } from 'react';
import { ChatMessage as ChatMessageType } from '../types/chat.types';
import { ChatMessage } from './ChatMessage';
import { TypingIndicator } from './TypingIndicator';
import '../styles/ChatWindow.css';

interface ChatWindowProps {
  messages: ChatMessageType[];
  isLoading?: boolean;
  onFeedback?: (messageId: string, feedback: 'positive' | 'negative') => void;
}

export const ChatWindow: React.FC<ChatWindowProps> = ({
  messages,
  isLoading = false,
  onFeedback
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, isLoading]);

  return (
    <div className="chat-window">
      {messages.length === 0 && !isLoading ? (
        <div className="chat-window-empty">
          <div className="chat-window-empty-icon">💬</div>
          <div className="chat-window-empty-title">Welcome to Cribsy Chat!</div>
          <div className="chat-window-empty-subtitle">
            Ask me anything about Cribsy, developmental milestones, or infant care.
          </div>
        </div>
      ) : (
        <div className="chat-window-messages">
          {messages.map((message) => (
            <ChatMessage
              key={message.id}
              message={message}
              onFeedback={onFeedback}
            />
          ))}
          {isLoading && <TypingIndicator />}
          <div ref={messagesEndRef} />
        </div>
      )}
    </div>
  );
};
